import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import LiveChat from '@/components/LiveChat';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsConditions from '@/pages/TermsConditions';

import PrivateLimited from '@/pages/services/PrivateLimited';
import LLP from '@/pages/services/LLP';
import OPC from '@/pages/services/OPC';
import Proprietorship from '@/pages/services/Proprietorship';
import Section8 from '@/pages/services/Section8';
import GST from '@/pages/services/GST';
import FSSAI from '@/pages/services/FSSAI';
import Trademark from '@/pages/services/Trademark';
import {
  NidhiCompany,
  IEC,
  ESI,
  PF,
  PT,
  MSME,
  ShopEstablishment,
  StartupIndia,
  DirectorChange,
  AddressChange,
  MOAAmendment,
  IncreaseCapital,
} from '@/pages/services/OtherServices';
import PvtLtdCompliance from '@/pages/services/PvtLtdCompliance';
import {
  LLPCompliance,
  OPCCompliance,
  ProprietorshipCompliance,
  Section8Compliance,
} from '@/pages/services/ComplianceServices';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            
            <Route path="/services/private-limited" element={<PrivateLimited />} />
            <Route path="/services/llp" element={<LLP />} />
            <Route path="/services/opc" element={<OPC />} />
            <Route path="/services/proprietorship" element={<Proprietorship />} />
            <Route path="/services/section-8" element={<Section8 />} />
            <Route path="/services/nidhi-company" element={<NidhiCompany />} />
            
            <Route path="/services/gst" element={<GST />} />
            <Route path="/services/fssai" element={<FSSAI />} />
            <Route path="/services/trademark" element={<Trademark />} />
            <Route path="/services/iec" element={<IEC />} />
            <Route path="/services/esi" element={<ESI />} />
            <Route path="/services/pf" element={<PF />} />
            <Route path="/services/pt" element={<PT />} />
            <Route path="/services/msme" element={<MSME />} />
            <Route path="/services/shop-establishment" element={<ShopEstablishment />} />
            <Route path="/services/startup-india" element={<StartupIndia />} />
            
            <Route path="/services/director-change" element={<DirectorChange />} />
            <Route path="/services/address-change" element={<AddressChange />} />
            <Route path="/services/moa-amendment" element={<MOAAmendment />} />
            <Route path="/services/increase-capital" element={<IncreaseCapital />} />
            
            <Route path="/services/pvt-ltd-compliance" element={<PvtLtdCompliance />} />
            <Route path="/services/llp-compliance" element={<LLPCompliance />} />
            <Route path="/services/opc-compliance" element={<OPCCompliance />} />
            <Route path="/services/proprietorship-compliance" element={<ProprietorshipCompliance />} />
            <Route path="/services/section-8-compliance" element={<Section8Compliance />} />
          </Routes>
        <Footer />
        <WhatsAppButton />
        <LiveChat />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;